// AOW — drives the mobile product-card glare defined in
// aow-card-glare.css. Desktop/mouse visitors already get the shine on
// real :hover (see base.css's animate--hover-3d-lift), so this only
// runs on devices with no true hover. As the visitor scrolls up or down
// a product grid, whichever card (or row, on a 2-up mobile grid) is
// passing the vertical centre of the screen gets the glare class; it's
// removed once the card leaves that band, so scrolling back past a card
// replays the effect.
(function () {
  if (!window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var GLARE_CLASS = 'aow-card-glare';
  var CARD_SELECTOR = '.product-card-wrapper';
  var observedCards = new WeakSet();
  var observer;

  // IntersectionObserver fires an initial callback the moment observe() is
  // called for any card that already happens to sit in the centre band on
  // page load — with no scrolling involved. Left unguarded, that meant the
  // page could load with the first row already tilted. Ignore callbacks
  // until the visitor actually scrolls, so every card renders flat on
  // load and only starts tilting once a real scroll is under way.
  var hasScrolled = false;
  function onFirstScroll() {
    hasScrolled = true;
    window.removeEventListener('scroll', onFirstScroll);
  }
  window.addEventListener('scroll', onFirstScroll, { passive: true });

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        if (!hasScrolled) return;
        entries.forEach(function (entry) {
          entry.target.classList.toggle(GLARE_CLASS, entry.isIntersecting);
        });
      },
      { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
    );
    return observer;
  }

  function observeAll(root) {
    var scope = root || document;
    var obs = getObserver();
    scope.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      if (observedCards.has(card)) return;
      observedCards.add(card);
      obs.observe(card);
    });
  }

  observeAll(document);

  // Product grids can re-render (filtering/sorting, infinite scroll,
  // section reorder in the theme editor) — pick up any new cards
  // without needing a full page reload.
  var bodyObserver = new MutationObserver(function () {
    observeAll(document);
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
